import axios from "axios";

const realApi = axios.create({
  baseURL: "https://campaign.techsauce.co/api",
  timeout: 15000,
});

export const FileApi = {
  uploadFile: async (file?: File) => {
    let formData = new FormData();
    if (file) formData.append("file", file);
    const result = await realApi.post("/upload", formData);
    return result.data.path;
  },
};
